import { Col, Row } from 'antd'
import PropTypes from 'prop-types'

import { CardSlider } from 'common/widgets'
import classNames from '../styles.module.scss'


CardWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  data: PropTypes.shape({
    static_content: PropTypes.object,
  }).isRequired,
}

export default function CardWrapper({ children, data }) {
  return (
    <div className={classNames.printBlock}>
      <Row className={classNames.cardWrapper}>
        <Col span={24} lg={7}>
          <CardSlider images={data.static_content?.media_images} priority />
        </Col>
        <Col span={24} lg={17} className={classNames.cardBody}>
          {children}
        </Col>
      </Row>
    </div>
  )
}
